import React from 'react';
import Modal from '@components/Modal';
import { I18n } from 'react-redux-i18n';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from 'yup';

const schema = yup.object().shape({
  email: yup
    .string()
    .required()
    .email(),
});

const ChangeParentEmail = ({ show, close, onSave, email }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({
    reValidateMode: 'onChange',
    defaultValues: { email },
    resolver: yupResolver(schema),
  });

  const onSubmit = data => onSave(data);

  return (
    <Modal
      show={show}
      close={close}
      hideClose={true}
      dialogClassName="with-robot-head"
      id="modal-editProfile"
    >
      <div className="row modal-robot-body text-center ">
        <div className="robot-head">
          <img
            src={require('../../../assets/images/robot-green-happy-head.svg')}
            alt="progkids-green-robot"
          />
        </div>
        <br />

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="col-xs-12 form-group"
        >
          <div className={`form-group has-success`}>
            <span>{I18n.t('placeholder.email')}:</span>
            <input
              type="email"
              className="form-control"
              autoComplete="email"
              {...register('email')}
            />
            <span className="help-block">
              {errors.email && errors.email.message}
            </span>
          </div>

          <button
            className="btn btn-green-small text-uppercase"
            disabled={!isDirty}
          >
            {I18n.t('main.buttons.save')}
          </button>
        </form>
      </div>
    </Modal>
  );
};

export default ChangeParentEmail;
